import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
// Get this from your EmailJS dashboard under Account > API Keys
emailjs.init("kd2QKlBwUv7L-lqyF");

interface ContactFormData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  message: string;
}

interface FooterEmailData {
  email: string;
  name?: string;
  title?: string;
}

export const sendContactEmail = async (params: ContactFormData): Promise<{ success: boolean; message: string }> => {
  try {
    const templateParams = {
      name: `${params.firstName} ${params.lastName}`,
      time: new Date().toLocaleString(),
      message: params.message,
      email: params.email,
      phone: params.phone,
      to_name: 'R . L Co., Ltd.',
      title: 'Contact Form Submission',
    };

    const response = await emailjs.send(
      'service_1j6rwgm', // Your EmailJS service ID
      'template_3zahkun', // Your EmailJS template ID
      templateParams
    );

    if (response.status === 200) {
      return {
        success: true,
        message: 'contact.form.success'
      };
    } else {
      throw new Error('Failed to send email');
    }
  } catch (error) {
    console.error('Error sending email:', error);
    return {
      success: false,
      message: 'Failed to send email. Please try again later.'
    };
  }
};

export const sendFooterEmail = async (params: FooterEmailData): Promise<{ success: boolean; message: string }> => {
  try {
    const templateParams = {
      email: params.email,
      name: params.name || 'Website Footer',
      title: params.title || 'Footer Subscription',
    };

    const response = await emailjs.send(
      'service_1j6rwgm', // Replace with your EmailJS service ID for footer
      'template_jjlzxrf', // Replace with your EmailJS template ID for footer
      templateParams
    );

    if (response.status === 200) {
      return {
        success: true,
        message: 'contact.form.success'
      };
    } else {
      throw new Error('Failed to send email');
    }
  } catch (error) {
    console.error('Error sending footer email:', error);
    return {
      success: false,
      message: 'Failed to subscribe email. Please try again later.'
    };
  }
}; 